var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"work-parcel-list"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"parcels"},_vm._l((_vm.items ?? []),function(parcel){return _c('div',{key:parcel.uuid,staticClass:"parcel"},[_c('work-parcel-item',{staticClass:"parcel-data d-flex flex-row",attrs:{"data":parcel}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }